import { render, staticRenderFns } from "./PcqDsisTable.vue?vue&type=template&id=0138349c&scoped=true&"
import script from "./PcqDsisTable.vue?vue&type=script&lang=js&"
export * from "./PcqDsisTable.vue?vue&type=script&lang=js&"
import style0 from "./PcqDsisTable.vue?vue&type=style&index=0&id=0138349c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0138349c",
  null
  
)

export default component.exports